import { PageHero } from "../components/Shared";
import { EMAIL, PHONE, FONT_HEAD, FONT_BODY, NAVY, GOLD } from "../lib/constants";

export const LegalSection = ({ title, children }) => (
  <div className="mb-8">
    <h2 className="text-xl font-bold mb-3" style={{ fontFamily: FONT_HEAD, color: NAVY }}>
      {title}
    </h2>
    <div className="text-sm leading-relaxed space-y-3" style={{ color: "#4B5563", fontFamily: FONT_BODY }}>
      {children}
    </div>
  </div>
);

export const LegalLayout = ({ badge, title, testid, children }) => (
  <>
    <PageHero testid={`${testid}-hero`} badge={badge} title={title} subtitle="Cindyrella Cleaning LLC — Naples, FL" />
    <section data-testid={testid} className="py-14 md:py-20" style={{ background: "#FFFFFF" }}>
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <p className="text-xs mb-10 uppercase tracking-widest font-bold" style={{ color: GOLD, fontFamily: FONT_BODY }}>
          Last updated: July 2026
        </p>
        {children}
        <p className="text-sm mt-10" style={{ color: "#6B7280", fontFamily: FONT_BODY }}>
          Questions? Contact us at {EMAIL} or {PHONE}. Cindyrella Cleaning LLC — Naples, FL, Collier County.
        </p>
      </div>
    </section>
  </>
);
